module.exports = __webpack_public_path__ + "img/company.6660af7d.png";